import { render, staticRenderFns } from "./CategoryContainerMonoCat.vue?vue&type=template&id=aa563e84"
import script from "./CategoryContainerMonoCat.vue?vue&type=script&lang=js"
export * from "./CategoryContainerMonoCat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports